import { useEffect, useRef, useState } from "react";
import WriteTabbarItemMobile from "components/community/write/write_tabbar_item_m";
import WriteAddImageSlider from "components/community/write/write_add_image_slider";
import {
  createCommunityPost,
  editCommunityPost,
  getBoardData,
  getBoardDataWithComment,
} from "firebase_/firebase_function/firebase_community";
import { useUser } from "util/context/user_context";
import ConfirmDialog from "components/confirm_dialog";
import OnlyConfirmDialog from "components/onlyConfirm_dialog";
import { useNavigate, useParams } from "react-router-dom";
import Styles from "css/community_css/mobile/community_write_m.module.css";
import OnlyLoadingPage from "components/loading_page";
import OnlyLoadingScreen from "components/loading_screen";

export default function CommunityEditScreen({ isMobile }) {
  /// ✅ 파라미터
  const { docId } = useParams();

  /// ✅ context
  const { userData } = useUser();
  const navigate = useNavigate();

  /// ✅ 탭 바 관련
  const tabBarItem = ["이야기", "고장문의"];
  const [selectTabBar, setSelectTabBar] = useState("");

  /// ✅ 글쓰기 요소
  const [images, setImages] = useState([]); // 추가한 이미지
  const [title, setTitle] = useState(""); // 제목
  const [body, setBody] = useState(""); // 내용

  /// ✅ 확인모달 관련
  const [onlyConfirmModal, setOnlyConfirmModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  /// ✅ 로딩관련
  const [loading, setLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(true);
  const initRef = useRef(true);

  useEffect(() => {
    if (docId) {
      fetchBoardData();
    }
  }, [docId]);

  /// ✅ 게시글 데이터 불러오기
  const fetchBoardData = async () => {
    setInitLoading(true);

    const boardData = await getBoardData(docId);

    if (boardData) {
      setTitle(boardData.title);
      setBody(boardData.body);
      setImages(boardData.imageUrls);
    }

    setInitLoading(false);
  };

  /// ✅ 글 수정
  const handleEditPost = async () => {
    setLoading(true);

    /// file만 추출
    // console.log("images", images);
    const imageFiles = images.map((imageData) =>
      typeof imageData === "string" ? imageData : imageData.file[0]
    ); // file ?? firebaseUrl
    // console.log("imageFiles", imageFiles);
    const result = await editCommunityPost(docId, title, body, imageFiles);

    if (result) {
      setOnlyConfirmModal(true);
      setModalMessage("글 등록에 성공했습니다.");
      navigate(`/community/${docId}`);
    } else {
      setOnlyConfirmModal(true);
      setModalMessage("글 등록에 실패했습니다.");
    }

    setLoading(false);
  };

  return (
    <>
      <div style={{ width: "100%", backgroundColor: "#ffffff" }}>
        <div
          style={{
            maxWidth: "1248px",
            padding: "16px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            margin: "auto",
          }}
        >
          <div className="f18_1F2937_W600">글 수정</div>
        </div>
      </div>
      <div className={Styles.divider} />

      {initLoading ? (
        <div
          style={{
            height: "400px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <OnlyLoadingPage />
        </div>
      ) : (
        <div
          className={Styles.container}
          style={{ maxWidth: "672px", margin: "auto" }}
        >
          <div className={Styles.spacer24} />
          <div className={Styles.spacer24} />

          <div
            className="f14_9CA3AF_W400"
            style={{ display: "flex", justifyContent: "end" }}
          >
            {"(" + title.length + "/100)"}
          </div>
          <input
            value={title}
            onChange={(e) => {
              if (e.target.value.length > 100) {
                setOnlyConfirmModal(true);
                setModalMessage("제목은 100글자 이내로 작성해주세요.");
                return;
              }
              setTitle(e.target.value);
            }}
            className={`${Styles.input} f16_1F2937_W400`}
            placeholder="제목을 입력하세요"
          />

          <div className={Styles.spacer24} />

          <div
            className="f14_9CA3AF_W400"
            style={{ display: "flex", justifyContent: "end" }}
          >
            {"(" + body.length + "/5000)"}
          </div>
          <textarea
            value={body}
            onChange={(e) => {
              if (e.target.value.length > 5000) {
                setOnlyConfirmModal(true);
                setModalMessage("내용은 5000글자 이내로 작성해주세요.");
                return;
              }
              setBody(e.target.value);
            }}
            className={`${Styles.textarea} f16_1F2937_W400`}
            style={{ height: "192px" }}
            placeholder="내용을 입력하세요"
          />

          <div className={Styles.spacer24} />

          <div style={{ display: "flex", flexDirection: "row", gap: "12px" }}>
            <div className="f14_4B5563_W400">사진 첨부</div>
            <div className="f14_9CA3AF_W400">
              {"("}
              {images.length}
              {"/5)"}
            </div>
          </div>

          <div style={{ height: "18px" }} />

          <WriteAddImageSlider images={images} setImages={setImages} />

          <div style={{ height: "56px" }} />
          {!isMobile && (
            <>
              <div
                style={{ display: "flex", flexDirection: "row", gap: "16px" }}
              >
                <div
                  onClick={() => navigate(`/community/${docId}`)}
                  className={`${Styles.postButton} f16_000000_W500`}
                  style={{ flex: "1", backgroundColor: "#dfdfdf" }}
                >
                  취소
                </div>
                <div
                  onClick={() => {
                    if (!title || !body) {
                      setOnlyConfirmModal(true);
                      setModalMessage("제목 또는 내용이 비어있습니다.");
                      return;
                    }
                    setConfirmModal(true);
                  }}
                  className={`${Styles.postButton} f16_FFFFFF_W500`}
                  style={{ flex: "1" }}
                >
                  수정하기
                </div>
              </div>
              <div style={{ height: "56px" }} />
            </>
          )}
          {isMobile && (
            <div
              style={{
                position: "sticky",
                bottom: "0px",
                width: "100%",
                background: "#FFFFFF",
                padding: "16px",
                borderTop: "1px solid #E5E7EB",
                borderBottom: "1px solid #E5E7EB",
              }}
            >
              <div
                style={{ display: "flex", flexDirection: "row", gap: "16px" }}
              >
                <div
                  onClick={() => navigate(`/community/${docId}`)}
                  className={`${Styles.postButton} f16_000000_W500`}
                  style={{ flex: "1", backgroundColor: "#dfdfdf" }}
                >
                  취소
                </div>
                <div
                  onClick={() => {
                    if (!title || !body) {
                      setOnlyConfirmModal(true);
                      setModalMessage("제목 또는 내용이 비어있습니다.");
                      return;
                    }
                    setConfirmModal(true);
                  }}
                  className={`${Styles.postButton} f16_FFFFFF_W500`}
                  style={{ flex: "1" }}
                >
                  수정하기
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <ConfirmDialog
        open={confirmModal}
        onClose={() => setConfirmModal(false)}
        onConfirm={() => handleEditPost()}
        message={"내용을 수정하시겠습니까?"}
      />

      <OnlyConfirmDialog
        open={onlyConfirmModal}
        onClose={() => setOnlyConfirmModal(false)}
        message={modalMessage}
      />
      <OnlyLoadingScreen isOpen={loading} />
    </>
  );
}
